import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSomalia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1412)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#338AF3"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12 6.26086L13.2951 10.2466H17.4859L14.0954 12.7099L15.3905 16.6957L12 14.2323L8.60954 16.6957L9.9046 12.7099L6.51408 10.2466H10.7049L12 6.26086Z",
			fill: "#F0F0F0"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1412",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSomalia;
